import React, { useId } from 'react';
import { AdornedInput, Box, Range, Text, Tooltip } from '@zillow/constellation-10';

import type { InputAndSliderProps } from './../types';

const InputAndSlider: React.FC<React.PropsWithChildren<React.PropsWithChildren<InputAndSliderProps>>> = ({
  title,
  min,
  max,
  step,
  value,
  leftAdornment,
  rightAdornment,
  onChange,
  tooltipText,
}: InputAndSliderProps) => {
  const titleId = useId();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onChange(value);
  };

  return (
    <Box
      css={{
        paddingBlock: '600',
        width: { base: '100%', lg: '50%' },
        maxWidth: { base: '100%', lg: 'calc(50% - {spacing.300})' },
        padding: { base: '{spacing.400} 0' },
      }}
    >
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '600' }}>
        <Text textStyle="body-sm-bold" asChild>
          <h4>
            <span id={titleId}>{title}</span> <Tooltip content={tooltipText} />
          </h4>
        </Text>
        {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 150px` falls between `3600` (144px) and `4000` (160px) on the numeric sizes scale */}
        <AdornedInput.Root css={{ width: '150px' }}>
          {leftAdornment && <AdornedInput.Adornment>{leftAdornment}</AdornedInput.Adornment>}
          <AdornedInput.Input aria-labelledby={titleId} value={value} onChange={handleChange} />
          {rightAdornment && <AdornedInput.Adornment>{rightAdornment}</AdornedInput.Adornment>}
        </AdornedInput.Root>
      </Box>
      <Range aria-labelledby={titleId} min={min} max={max} value={value} onChange={handleChange} step={step} />
    </Box>
  );
};

export default InputAndSlider;
